import swal from "sweetalert";
import {
  CREATE_PERMISSION_FAIL,
  CREATE_PERMISSION_REQUEST,
  CREATE_PERMISSION_SUCCESS,
  SHOW_PERMISSION_FAIL,
  SHOW_PERMISSION_REQUEST,
  SHOW_PERMISSION_SUCCESS,
} from "../../ActionType/BranchType/PermissionType";
import { api } from "../../Api/api";
import { getToken } from "../login";

export const createPermissionAction =
  (listPagePermission, role_id) => async (dispatch) => {
    const config = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    };
    // console.log(listPagePermission)
    let route = [];
    let page_id = [];
    let permission = [];
    listPagePermission.map((list) => {
      page_id.push(list.id || 0);
      permission.push(list.isToggled || false);
      route.push(list.route);
    });

    dispatch({
      type: CREATE_PERMISSION_REQUEST,
      payload: [],
    });
    try {
      const response = await api.post(
        "permission/create",
        { role_id, page_id, route, permission },
        config
      );
      const { status, data } = response;

      if (status == 201) {
        dispatch(showPermissionAction(role_id));
        dispatch(showPermissionAction(role_id));
        // console.log(response);
        swal({
          title: "Good job!",
          text: "Permission was Save Successfully !",
          icon: "success",
          button: "OK",
          timer: 2000,
        });
        dispatch({
          type: CREATE_PERMISSION_SUCCESS,
          payload: data,
        });
      }
    } catch (error) {
      console.log(error);

      dispatch({
        type: CREATE_PERMISSION_FAIL,
        payload: [],
      });
    }
  };

export const showPermissionAction = (role_id) => async (dispatch) => {
  const config = {
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
  };

  dispatch({
    type: SHOW_PERMISSION_REQUEST,
    payload: [],
  });
  try {
    const response = await api.get("permission/show/" + role_id, config);
    const { status, data } = response;
    if (status == 200) {
      dispatch({
        type: SHOW_PERMISSION_SUCCESS,
        payload: data,
      });
    }
  } catch (error) {
    dispatch({
      type: SHOW_PERMISSION_FAIL,
      payload: [],
    });
  }
};

export const updatePermissionAction =
  (listPagePermission, role_id, permissionIds) => async (dispatch) => {
    const config = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    };

    let page_id = [];
    let permission = [];
    let route = [];

    listPagePermission.map((list) => {
      page_id.push(list.id);
      permission.push(list.isToggled);
      route.push(list.route);
    });

    dispatch({
      type: SHOW_PERMISSION_REQUEST,
      payload: [],
    });
    try {
      const response = await api.put(
        "permission/update",
        {
          role_id,
          page_id,

          permission,
          ids: permissionIds,
          route,
        },
        config
      );
      const { status, data } = response;

      if (status == 200) {
        swal({
          title: "Good job!",
          text: "Permission was Update Successfully !",
          icon: "success",
          button: "OK",
          timer: 2000,
        });
        dispatch(showPermissionAction(role_id));
        dispatch(showPermissionAction(role_id));
        dispatch({
          type: SHOW_PERMISSION_SUCCESS,
          payload: data,
        });
      }
    } catch (error) {
      dispatch({
        type: SHOW_PERMISSION_FAIL,
        payload: [],
      });
    }
  };
